import { Link } from "react-router-dom";
import HankoSeal from "@/components/HankoSeal";

export default function ThankYou({ title }) {
  return (
    <main className="min-h-screen flex items-center justify-center px-6" data-testid="thank-you-page">
      <div className="text-center max-w-md">
        <div className="inline-block animate-seal-drift">
          <HankoSeal size={110} animate={false} />
        </div>
        <h1 className="mt-8 font-serif text-3xl sm:text-4xl text-sumi leading-tight">{title}</h1>
        <p className="mt-5 text-charcoal/75 leading-relaxed">
          Am primit cererea ta. Te contactăm în maximum 24 de ore.
        </p>
        <p className="mt-3 font-jp text-hanko text-lg">ありがとう — mulțumim!</p>
        <Link
          to="/"
          data-testid="thank-you-home-link"
          className="mt-9 inline-block bg-hanko text-washi font-semibold px-8 py-3.5 rounded-full hover:bg-hankodeep transition-colors duration-300"
        >
          Înapoi la pagina principală
        </Link>
      </div>
    </main>
  );
}
